import React from "react";
import {useHistory} from "react-router";
import MButton from "@/components/atom/MButton";

const Uses = () => {
  const history = useHistory()

  return (
    <div className="App" style={{padding: '40px'}}>
      <h1>サイトのご利用について</h1>

      <p>
        「名刺R」のご利用には名刺を渡す方、名刺をいただく方に関わらず「名刺R」への登録が必要です。登録は無料です。返信出来るメールアドレス、パスワードは8文字以上で入力してください。登録後に登録完了メールが送られてきますので、内容にしたがって名刺R会員登録をしてください。
      </p>
      <p>
        名刺の受取のみに使用する場合は料金がかかりませんが、名刺を渡すには名刺の登録が必要、名刺1点の登録で550円(税込)が必要で名刺のQRが作成されます。登録した名刺をお渡しするユーザー数が50名までは無料、51名〜500名まで550円/月(税込)、501名〜770円/月(税込)必要です。
      </p>
      <MButton image={'back.png'} onClick={() => history.goBack()} value={'戻る'} />
    </div>
  )
}

export default Uses;
